import { useId, useState, useSyncExternalStore } from 'react';
import { Download } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/Dialog';
import { useTranslation } from 'react-i18next';
import { installHelpKey, isInstalled, requestInstall, subscribeInstall } from '../../../packages/browser-app/install';

export function InstallApp() {
    const { t } = useTranslation();
    const installed = useSyncExternalStore(subscribeInstall, isInstalled, () => false);
    const [help, setHelp] = useState(false);
    const [busy, setBusy] = useState(false);
    const helpId = useId();
    if (installed) return null;
    return (
        <div className="my-2 min-w-0 print:hidden">
            <button type="button" disabled={busy} aria-expanded={help} aria-controls={helpId} aria-haspopup="dialog"
                className="flex min-h-[48px] w-full items-center justify-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium hover:bg-primary/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-50"
                onClick={async () => {
                    setBusy(true);
                    const outcome = await requestInstall();
                    setHelp(outcome === 'manual' || outcome === 'failed');
                    setBusy(false);
                }}>
                <Download size={18} aria-hidden="true" />{t(busy ? 'appInstall.pending' : 'appInstall.label')}
            </button>
            <Dialog open={help} onOpenChange={setHelp}>
                <DialogContent id={helpId} className="max-w-md">
                    <DialogHeader>
                        <DialogTitle>{t('appInstall.label')}</DialogTitle>
                        <DialogDescription className="pt-2 leading-6">{t(installHelpKey())}</DialogDescription>
                    </DialogHeader>
                </DialogContent>
            </Dialog>
        </div>
    );
}
